import React, { useContext, useState } from 'react';
import axios from 'axios';
import { baseUrl } from '../utils/constants';

const initialJournal = {
  refId: 0,
  voucherNo: '',
  payCycleID: '',
  claimNo: '',
  details: '',
  chequeNo: '',
  userId: 0,
  controlAcc: '',
  debit: 0,
  credit: 0,
  dateProcessed: ''
};

const initialAnalysis = {
  refId: 0,
  journalRefId: 0,
  creditor: '',
  debitAward: 0,
  creditAward: 0,
  claimNo: '',
  membershipNo: '',
  namasNo: ''
};

export const AccountingContext = React.createContext();

export const AccountingProvider = ({ children }) => {
  const [refId, setRefId] = useState(-1);
  const [refIdSelf, setRefIdSelf] = useState(-1);
  const [currentJournal, setCurrentJournal] = useState(initialJournal);
  const [analysisRefId, setAnalysisRefId] = useState(-1);
  const [currentAnalysis, setCurrentAnalysis] = useState(initialAnalysis);
  const [analysisList, setAnalysisList] = useState([]);
  const [analysisSelfList, setAnalysisSelfList] = useState([]);
  const [transactionList, setTransactions] = useState([]);
  const [fileSubList, setFileSubList] = useState([]);
  const [changeSubList, setChangeSubList] = useState([]);

  const clearJournals = () => {
    setRefId(-1);
    setCurrentJournal(initialJournal);
    setAnalysisRefId(-1);
    setCurrentAnalysis(initialAnalysis);
  };

  const clearBatch = () => {
    setAnalysisRefId(-1);
    setCurrentAnalysis(initialAnalysis);
  };

  const refreshJournalById = async (refid) => {
    await axios(`${baseUrl}/api/accounting/GetJournalById?refId=${refId}`).then(
      (result) => {
        console.log('returned claim info in context', result);
        // setCurrentClaim(result.data.result);
      },
      (error) => {
        alert('failed');
      }
    );
  };

  const getAnalysisDetailsById = async (refId) => {
    await axios(`${baseUrl}/api/accounting/getAnalysisDetailsById?refId=${refId}`).then(
      (result) => {
        setAnalysisList(result.data.result);
      },
      (error) => {
        alert('failed');
      }
    );
  };

  const getAnalysisSelfById = async (refIdSelf) => {
    await axios(`${baseUrl}/api/accounting/getAnalysisSelfDetailsById?refId=${refIdSelf}`).then(
      (result) => {
        setAnalysisSelfList(result.data.result);
      },
      (error) => {
        alert('failed');
      }
    );
  };

  const getTransactions = async (accountRefId, cycleDate) => {
    await axios(
      `${baseUrl}/api/accounting/GetTransactionsByAccountRef?accountRefId=${accountRefId}&cycleDate=${cycleDate}`
    ).then(
      (result) => {
        setTransactions(result.data);
      },
      (error) => {
        alert('failed');
      }
    );
  };

  return (
    <AccountingContext.Provider
      value={{
        refId,
        setRefId,
        currentJournal,
        setCurrentJournal,
        currentAnalysis,
        getAnalysisDetailsById,
        refreshJournalById,
        analysisList,
        clearJournals,
        setAnalysisList,
        refIdSelf,
        setRefIdSelf,
        analysisSelfList,
        setAnalysisSelfList,
        getAnalysisSelfById,
        getTransactions,
        transactionList,
        fileSubList,
        changeSubList,
        setChangeSubList,
        setFileSubList
      }}
    >
      {children}
    </AccountingContext.Provider>
  );
};

export const useAccountingContext = () => useContext(AccountingContext);
